export const testimonials = [
  {
    name: "Rajesh Kumar",
    role: "Plant Manager",
    company: "Thermal Power Plant",
    text: "Adixi Engineering has been instrumental in maintaining our plant efficiency. Their technical team is highly skilled and responsive. The mechanical maintenance work they deliver is exceptional.",
    rating: 5
  },
  {
    name: "Amit Sharma",
    role: "Project Director",
    company: "Leading Cement Manufacturer",
    text: "We've been working with Adixi for our instrumentation needs. Their expertise in SCADA and PLC systems has significantly improved our automation. Highly recommended!",
    rating: 5
  },
  {
    name: "Priya Verma",
    role: "Operations Head",
    company: "Industrial Plant - UP",
    text: "The manpower services provided by Adixi are top-notch. Their engineers are well-trained and professional. They handle O&M contracts with complete dedication and reliability.",
    rating: 5
  }
];